import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {NgClass} from '@angular/common';

@Component({
  selector: 'sqep-button',
  imports: [MatButton, MatIconModule, MatProgressSpinnerModule, NgClass],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonComponent {
  buttonClick = output<MouseEvent>();
  readonly disabled = input<boolean>(false);
  readonly showSpinner = input<boolean>(false);
  readonly buttonIcon = input<string>('');
  readonly buttonIconPosition = input<'start' | 'end'>('start');
  readonly buttonCaption = input<string>('');
  readonly buttonTheme   = input<string>('');
  readonly buttonType    = input<'button' | 'submit' | 'reset'>('button');
}
